export enum Gender {
  MALE = "M",
  FEMALE = "F",
}

export const GenderTranslations: Record<Gender, string> = {
  [Gender.MALE]: "Masculino",
  [Gender.FEMALE]: "Femenino",
};

export const GenderColors = {
  [Gender.MALE]: "blue",
  [Gender.FEMALE]: "pink",
} as const;

export enum BloodType {
  A_POSITIVE = "A+",
  A_NEGATIVE = "A-",
  B_POSITIVE = "B+",
  B_NEGATIVE = "B-",
  AB_POSITIVE = "AB+",
  AB_NEGATIVE = "AB-",
  O_POSITIVE = "O+",
  O_NEGATIVE = "O-",
}
export interface PersonalInformation {
  id: number;
  dni: string;
  user_id: number;
  licence_number?: string;
  first_name: string;
  last_name: string;
  birth_date: Date;
  email?: string;
  primary_phone_number: string;
  secondary_phone_number?: string;
  emergency_contact_number?: string;
  gender: Gender;
  blood_type?: string;
  is_active: boolean;
  created_at: Date;
  updated_at: Date;
}

export interface PersonalInfoCreate {
  dni: string;
  first_name: string;
  last_name: string;
  primary_phone_number: string;
  licence_number?: string;
  birth_date: string;
  email?: string;
  secondary_phone_number?: string;
  emergency_contact_number?: string;
  gender?: Gender;
  blood_type?: BloodType;
}

export interface PersonalInfoApiError {
  dni: string | null;
  email: string | null;
  licence_number: string | null;
}

